import Service from '../Service';

export default class OrderItemService extends Service{

    constructor(){
        super('');
        this.resource = "order-items";
    }

    async createRequestUrl(query){
        let requestUrl = `${this.resource}?`
        
        if(query)
            query = this.encodeQueryValues(query);

        if(query && query.orcamento)
            requestUrl += this.hasParameter(requestUrl) ? `&ORCAMENTO=${query.orcamento}` : `ORCAMENTO=${query.orcamento}`

        return requestUrl;
    }

    async getOrderItens(query){
        let requestUrl = await this.createRequestUrl(query);
        return await this.getAPI(requestUrl);
    }

    async insertOrderItem(payload){
        let data = payload;
        return await this.insert(data);
    }

}